import { ArrowRight } from "lucide-react";
import IMAGES from "../data/imageMap";
import { useSiteContent } from "../contexts/SiteContent";

export default function Hero() {
  const { t } = useSiteContent();
  const onExplore = () => {
    const el = document.getElementById("breakthroughs");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero"
      className="relative w-full pt-28 pb-24 md:pt-36 md:pb-32 overflow-hidden bg-white"
    >
      <div className="absolute inset-0 -z-10">
        <img
          src={IMAGES.hero}
          alt=""
          className="w-full h-full object-cover opacity-90"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-white/10 to-white" />
      </div>

      <div className="relative mx-auto max-w-[1280px] px-4 md:px-6 text-center">
        <p
          data-testid="hero-eyebrow"
          className="text-[13px] uppercase tracking-[0.18em] text-neutral-600 font-medium"
        >
          {t("hero.eyebrow", "Science")}
        </p>

        <h1
          data-testid="hero-headline"
          className="mt-5 text-[40px] leading-[1.05] sm:text-[52px] md:text-[64px] font-semibold tracking-[-0.02em] text-neutral-900 max-w-[920px] mx-auto"
        >
          {t("hero.headline", "Unlocking a new era of discovery with AI")}
        </h1>

        <p className="mt-6 text-[16px] md:text-[17px] text-neutral-600 max-w-[640px] mx-auto leading-relaxed">
          {t(
            "hero.subhead",
            "We're building AI systems that help scientists accelerate discovery, tackle humanity's greatest challenges, and expand the frontiers of human knowledge."
          )}
        </p>

        <div className="mt-9">
          <button
            type="button"
            onClick={onExplore}
            data-testid="hero-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-neutral-900 px-6 h-11 text-[14px] font-medium text-white transition-all hover:bg-neutral-800 hover:gap-3"
          >
            {t("hero.cta_label", "Explore our breakthroughs")}
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </button>
        </div>
      </div>
    </section>
  );
}
